import { Pipe, PipeTransform } from '@angular/core';

import { trimestres } from '../../../models/trimestre';

@Pipe({
    name: 'trimestre'
})
export class TrimestrePipe implements PipeTransform {
    transform(trimestre: number): string {
        if (!trimestre) {
            return '';
        }

        const index = trimestres.findIndex(trimestreFilter => trimestreFilter.trimestre === trimestre);
        if (index > -1) {
            return trimestres[index].nome;
        }
        return '';
    }
}
